import { createConsumer } from '@rails/actioncable';
import { create } from 'zustand';

type Consumer = ReturnType<typeof createConsumer>;

type UseChannelStore = {
	consumer: Consumer;
	initialize: (url: string) => void;
};

export const useChannelStore = create<UseChannelStore>((set) => ({
	consumer: null as any,
	// Tear down any existing consumer before replacing it. Web initializes once
	// (guarded by a ref), but the desktop MFE re-initializes on OAuth token
	// refresh to reconnect the cable with a fresh `?access_token=`, so the old
	// socket must be disconnected to avoid a leaked duplicate subscription.
	initialize: (url: string) =>
		set((state) => {
			if (state.consumer) state.consumer.disconnect();
			return { consumer: createConsumer(url) };
		}),
}));
